/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PersonIdFinancialDataQueryResponse,
  GetApiV1PersonIdFinancialDataPathParams,
  GetApiV1PersonIdFinancialData401,
  GetApiV1PersonIdFinancialData404,
  GetApiV1PersonIdFinancialData500,
} from "../../types/personFinancialController/GetApiV1PersonIdFinancialData.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PersonIdFinancialData } from "../../clients/personFinancialController/getApiV1PersonIdFinancialData.ts";

export const getApiV1PersonIdFinancialDataQueryKey = (
  id: GetApiV1PersonIdFinancialDataPathParams["id"],
) =>
  [{ url: "/api/v1/person/:id/financial-data", params: { id: id } }] as const;

export type GetApiV1PersonIdFinancialDataQueryKey = ReturnType<
  typeof getApiV1PersonIdFinancialDataQueryKey
>;

export function getApiV1PersonIdFinancialDataQueryOptions(
  id: GetApiV1PersonIdFinancialDataPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PersonIdFinancialDataQueryKey(id);
  return queryOptions<
    GetApiV1PersonIdFinancialDataQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonIdFinancialData401
      | GetApiV1PersonIdFinancialData404
      | GetApiV1PersonIdFinancialData500
    >,
    GetApiV1PersonIdFinancialDataQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PersonIdFinancialData(id, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna os dados da aba Financial da pessoa (banco, agência, contas, método de pagamento e tipo de conta). Inclui descrição textual dos enums (PaymentMethodName e AccountTypeName). **(Requer Authorization para autenticação)**
 * @summary Obter dados financeiros (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/financial-data}
 */
export function useGetApiV1PersonIdFinancialData<
  TData = GetApiV1PersonIdFinancialDataQueryResponse,
  TQueryData = GetApiV1PersonIdFinancialDataQueryResponse,
  TQueryKey extends QueryKey = GetApiV1PersonIdFinancialDataQueryKey,
>(
  id: GetApiV1PersonIdFinancialDataPathParams["id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PersonIdFinancialDataQueryResponse,
        ResponseErrorConfig<
          | GetApiV1PersonIdFinancialData401
          | GetApiV1PersonIdFinancialData404
          | GetApiV1PersonIdFinancialData500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1PersonIdFinancialDataQueryKey(id);

  const query = useQuery(
    {
      ...getApiV1PersonIdFinancialDataQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1PersonIdFinancialData401
      | GetApiV1PersonIdFinancialData404
      | GetApiV1PersonIdFinancialData500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
